import { useState } from "react";
import cookie from "js-cookie";
import { getIntouch } from "../../../api.services.js/others";
import { Button, Form, Modal } from "react-bootstrap";

export const ImageList = ({ tileData }) => {
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);

  const [showAllTiles, setShowAllTiles] = useState(false);
  const [displayedTileData, setDisplayedTileData] = useState(
    tileData.slice(0, 6)
  );
  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
  });

  const submitGetInTouch = async () => {
    const namee = touch.name;
    const no = touch.number;
    const pin = touch.pincode;

    if (!namee || !no || !pin) {
      setTouch({
        ...touch,
        error: "All fields are required",
      });
    } else if (String(pin).length != 6) {
      setTouch({
        ...touch,
        error: "Invalid Pincode",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });
      let response = await getIntouch({
        name: namee,
        phone: no,
        pincode: pin,
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);
        swal(response?.message);
        setTouch({
          ...touch,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.get_in_touch.msg);
        // setGetInTouch(false)

        setTouch({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
        setIsExpertTalkClicked(false);
      }
    }
  };

  const handleViewMore = () => {
    if (!showAllTiles)
      setDisplayedTileData((prev) => [
        ...prev,
        ...tileData.slice(prev.length, prev.length + 6),
      ]);

    if (showAllTiles) setDisplayedTileData(tileData.slice(0, 6));

    if (displayedTileData.length + 6 >= tileData.length)
      setShowAllTiles(!showAllTiles);
  };

  return (
    <div className="designpage-category-row inner-design-gallery">
      <div className="designpage-category-row inner-design-gallery">
        {displayedTileData.map((tile, index) => (
          <div className="designpage-category-col" key={index}>
            <div className="designpage-figure">
              {tile.src ? (
                <img {...tile} loading="lazy" />
              ) : (
                <img src={tile.image} alt={tile.alt} loading="lazy" />
              )}
            </div>
            <div className="designpage-text">
              <button
                className="talk-expert-btn talk-to-expert-design-page"
                onClick={() => setIsExpertTalkClicked(true)}
              >
                Talk to Expert
              </button>
            </div>
          </div>
        ))}
      </div>
      {tileData.length > 6 && (
        <div className="tru_btn_new design-page">
          <button className="btn btn-primary" onClick={handleViewMore}>
            {showAllTiles ? "View Less" : "View More"}
          </button>
        </div>
      )}

      <Modal
        show={isExpertTalkClicked}
        className="pincode-popup-bx expert_assistance_modal ask-question-popup"
        onHide={() => {
          // setTimePopup(false)
          // setGetInTouch(false)
          setIsExpertTalkClicked(false);
          // localStorage.setItem('leadSkiped',true)
        }}
      >
        <Modal.Dialog>
          <Modal.Header closeButton>
            <Modal.Title>Get in touch with our tile expert</Modal.Title>
          </Modal.Header>
          <div className="ask-question-section">
            <div className="expert-fig-bx">
              <img src="/new-tareek.jpg" />
            </div>
            <Modal.Body>
              <h2>Ask Tile Expert</h2>
              <p>Let Experts Help You In Buying Process</p>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitGetInTouch();
                }}
              >
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Mobile</Form.Label>

                  <Form.Control
                    type="number"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        number: `${touch.countryCode || ""}${e.target.value}`, // Append the country code
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    value={touch.pincode}
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        pincode: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                {touch.error && (
                  <p className="error text-danger">{touch.error}</p>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  disabled={touch.loading}
                  style={{ width: "100%" }}
                >
                  {touch.loading ? "Submitting" : "Submit"}
                </Button>
              </Form>
            </Modal.Body>
          </div>
          {/* <Modal.Footer>
                      <Button variant="primary" onClick={() => handlePinSave()}>
                        Submit
                      </Button>
                    </Modal.Footer> */}
        </Modal.Dialog>
      </Modal>
    </div>
  );
};
